/**
 * form-element
 */

// eslint-disable-next-line
import $ from 'jquery';

// Adds select2 library.
import 'select2/dist/js/select2.full';
import 'select2/dist/css/select2.css';

// Module dependencies
import 'protons';

// Module template
import './_input.twig';
import './_select.twig';
import './_textarea.twig';
import './_form.css';

export const name = 'form-element';

// The following class names are added so that they don't get purged and are available in code.
// eslint-disable-next-line no-unused-vars
const classes = [
  'md:text-xs md:text-sm md:base md:text-xl md:text-2xl md:text-3xl md:text-4xl md:text-5xl',
  'lg:text-xs lg:text-sm lg:base lg:text-xl lg:text-2xl lg:text-3xl lg:text-4xl lg:text-5xl',
  'xl:text-xs xl:text-sm xl:base xl:text-xl xl:text-2xl xl:text-3xl xl:text-4xl xl:text-5xl',
];
export function disable() {}

// eslint-disable-next-line
export function enable($context) {
  // eslint-disable-next-line no-undef
  once('select-enhanced-init', 'select.enhanced', $context).forEach(
    function enhanceSelect(select) {
      $(select).select2();
    }
  );
}

export default enable;
